import React from "react"
import { RenderElementProps } from "slate-react"

const Li = ({ children, attributes }: RenderElementProps) => {
    return (
        <li {...attributes} className="mb-4 last:mb-0 sm:mb-5 pl-0 ml-5 sm:ml-7">
            {children}
        </li>
    )
}

export default Li
